module.exports = __webpack_public_path__ + "static/media/reel-thumbnail.f34660ec.jpg";